<div class="wrapper">
  <tun-player-view class="player"></tun-player-view>
  <tun-queue-view class="queue"></tun-queue-view>
</div>
